import { render, staticRenderFns } from "./HeaderSelfOrderBtn.vue?vue&type=template&id=75089cfc&scoped=true"
import script from "./HeaderSelfOrderBtn.vue?vue&type=script&lang=js"
export * from "./HeaderSelfOrderBtn.vue?vue&type=script&lang=js"
import style0 from "./HeaderSelfOrderBtn.vue?vue&type=style&index=0&id=75089cfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75089cfc",
  null
  
)

export default component.exports